import {gql} from 'apollo-angular';
import {ImageFragment} from "./fragments/Image";

export const GET_EVENTS_BC = gql`
  query GetEventsBc {
    getEventsBcByDistrict {
      id
      name
      description
      maxParticipants
      duration
      address {
        street
        number
        addressCity {
          name
          addressDistrict {
            name
            bkz
            id
          }
        }
      }
      eventState
      eventTags {
        tagName
      }
      appointments {
        startTime
        endTime
        startDate
        endDate
        note {
          link
          firstname
          lastname
          phone
          email
          remark
        }
        bookableUntil
        maxParticipantes
        appointmentType
        appointmentState
        bookingLink
      }
      image {
        ...imageFields
      }
    }
  }
  ${ImageFragment}
`;
